window.mcb.forms.fields = window.mcb.forms.fields || {};
window.mcb.forms.fields.extensions = window.mcb.forms.fields.extensions || {};
window.mcb.forms.fields.extensions.text = function (parent, shared) {
    const _logger = window.mcb.utilities.createLogger("forms.field.text", 'Forms Field (Text)');
    const _thisField = parent;
    const _shared = shared;
    let _validatedControlWrapper = null;
    let _control = null;
    let _validationCanvas = null;

    {
        // Init
        if (_thisField.settings.required) {
            const titleHidden = _thisField.settings.showTitle === false || _thisField.settings.title === null;
            if (titleHidden && _thisField.settings.placeholder !== null) {
                _thisField.settings.placeholder += window.mcb.forms.constants.fields.requiredMark;
            }
        }

        _thisField.validation = {
            required: _thisField.settings.required ?? false,
            isInteger: false,
            isNumeric: false,
            isEmail: false,
            modulus: null,
            regex: _thisField.settings.data.regex ?? null,
            regexError: _thisField.settings.data.regexError ?? null,
            prepend: null,
            prependLength: null,
            maxLength: _thisField.settings.data.maxlength ?? null,
            minLength: _thisField.settings.data.minlength ?? null,
            min: _thisField.settings.data.min ?? null,
            dirty: false
        };

        switch (_thisField.settings.data.type) {
            case 'mail':
                _thisField.validation.isEmail = true;
                break;
            case 'integer':
                _thisField.validation.isInteger = true;
                _thisField.validation.isNumeric = true;
                break;
            case 'postal':
                _thisField.validation.regex = "^([0-9]|[fF][oO]-)[0-9][0-9][0-9]$"
                _thisField.validation.regexError = 'PostalViolation';
                _thisField.validation.prepend = '0';
                _thisField.validation.prependLength = 4;
                break;
            case 'regno':
                _thisField.validation.regex = "^[0-9]{1,4}$"
                _thisField.validation.regexError = 'RegNoViolation';
                _thisField.validation.prepend = '0';
                _thisField.validation.prependLength = 4;
                break;
            case 'cpr':
                _thisField.validation.regex = "^(?:(?:31(?:0[13578]|1[02])|(?:30|29)(?:0[13-9]|1[0-2])|(?:0[1-9]|1[0-9]|2[0-8])(?:0[1-9]|1[0-2]))[0-9]{2}-?[0-9]|290200-?[4-9]|2902(?:(?!00)[02468][048]|[13579][26])-?[0-3])[0-9]{3}|000000-?0000$"
                _thisField.validation.regexError = 'CprViolation';
                break;
            case 'pinteger':
                _thisField.validation.isNumeric = true;
                _thisField.validation.prepend = '0';
                break;
            case 'giro':
                _thisField.validation.prepend = '0';
                _thisField.validation.maxLength = 8;
                _thisField.validation.isNumeric = true;
                break;
            case 'account':
                _thisField.validation.prepend = '0';
                _thisField.validation.maxLength = 10;
                _thisField.validation.isNumeric = true;
                break;
            case 'kreditor':
                _thisField.validation.regex = '^[1-9][0-9][0-9][0-9][0-9]$';
                _thisField.validation.regexError = 'KreditorViolation';
                break;
            case 'orgno':
                _thisField.validation.regex = "^[0-9][0-9][0-9][ \\.]?[0-9][0-9][0-9][ \\.]?[0-9][0-9][0-9]$"
                _thisField.validation.regexError = 'OrgNoViolation';
                break;
            case 'phone':
                _thisField.validation.regex = "^(\\+|00)?[1-9][0-9]{7,32}$"
                _thisField.validation.regexError = 'PhoneViolation';
                break;
            case 'cvr':
                _thisField.validation.modulus = {
                    modulus: 11,
                    weights: [2, 7, 6, 5, 4, 3, 2, 1],
                    error: 'CvrModulusViolation'
                }
                break;
            default:
                break;
        }

        if (_thisField.validation.prepend !== null) {
            _thisField.validation.min = 0;
            if (_thisField.validation.prependLength === null) {
                if (_thisField.validation.maxLength === null) {
                    throw new Error("maxLength is required when prepend is set");
                }

                _thisField.validation.prependLength = _thisField.validation.maxLength;
            }
        }

        if (_thisField.validation.regexError === null && _thisField.validation.regex === '^[A-Za-z0-9]+$') {
            _thisField.validation.regexError = 'AlphanumericViolation';
        }
    }

    const render = function () {
        _control = document.createElement('input');
        _control.classList.add(window.mcb.forms.constants.fields.controlClass);
        _control.classList.add(window.mcb.forms.constants.fields.uiInput);
        _control.id = _thisField.fieldValueControlId;
        _control.name = _thisField.alias;
        _control.type = 'text';

        if (_thisField.settings.addControlClasses ?? null !== null) {
            for (let i = 0; i < _thisField.settings.addControlClasses.length; i++) {
                _control.classList.add(_thisField.settings.addControlClasses[i]);
            }
        }

        if (_thisField.settings.aria ?? null !== null) {
            _control.ariaLabel = _thisField.settings.aria;
        }

        if (_thisField.settings.required ?? null !== null) {
            _control.ariaRequired = true;
        }

        if (_thisField.settings.autocomplete ?? null !== null) {
            _control.autocomplete = true;
        }

        if (_thisField.settings.placeholder ?? null !== null) {
            _control.placeholder = _thisField.settings.placeholder;
        }

        if (_thisField.settings.defaultValue ?? null !== null) {
            _control.value = _thisField.settings.defaultValue;
            _thisField.validation.dirty = true;
        }

        _control.addEventListener('focus', (event) => {
            _shared.validateEvent(event, _thisField, _control);

            if (_thisField.validation.prepend !== null) {
                let value = _control.value;
                if (value !== "" && !isNaN(value)) {
                    value = parseInt(value).toString();
                }

                if (value !== _control.value) {
                    _logger.trace('removed padding on focus: ' + _control.value + ' -> ' + value, _control);
                    _control.value = value;
                }
            }

            _shared.fireFieldModifiedEvents(_control, _thisField.applyValidationDuringInput);
        });

        _control.addEventListener('paste', (event) => {
            _shared.validateEvent(event, _thisField, _control);
            _shared.fireFieldModifiedEvents(event._control, _thisField.applyValidationDuringInput);
        });

        _control.addEventListener('keyup', (event) => {
            _shared.validateEvent(event, _thisField, _control);
            _shared.fireFieldModifiedEvents(event._control, _thisField.applyValidationDuringInput);
        });

        _control.addEventListener('blur', (event) => {
            _shared.validateEvent(event, _thisField, _control);
            _shared.fireFieldModifiedEvents(event._control, true, true);
        });

        _validationCanvas = document.createElement('div');
        _validationCanvas.classList.add(window.mcb.forms.constants.validation.validationTarget);

        _validatedControlWrapper = document.createElement('div');
        _validatedControlWrapper.classList.add(window.mcb.forms.constants.validation.validationWrapper);

        _validatedControlWrapper.appendChild(_control);
        _validatedControlWrapper.appendChild(_validationCanvas);

        return _validatedControlWrapper;
    };

    const getValue = function (allowValueFormatting = false) {
        window.mcb.forms.validation.clearValidationResults(_validationCanvas);

        if (_control === null) {
            throw new Error("Control is not initialized");
        }

        if (document.getElementById(_control.id) === null) {
            throw new Error("Control has been removed from DOM");
        }

        if (_control.offsetParent === null) {
            // Field is not visible
            return undefined;
        }

        let value = _control.value.trim();
        if (_thisField.settings.data.type === 'orgno') {
            value = value.replace(/[\.\s]/g, '');
        }

        let valueAsNumber = null;
        if (allowValueFormatting && value !== "") {
            if (_thisField.settings.data.type === 'phone') {
                if (value.startsWith('00')) {
                    value = '+' + value.substring(2);
                }

                const first = value[0];
                value = value.replace(/[\+\s]/g, '');
                if (first === '+') {
                    value = first + value;
                }
            }
            else if (_thisField.validation.isInteger) {
                try {
                    valueAsNumber = new Number(value);
                    _logger.trace('Value as number: ' + valueAsNumber, _control);
                }
                catch (e) {
                    valueAsNumber = null;
                    _logger.trace('Invalid number: ' + value, _control);
                }
            }

            if (value !== _control.value) {
                _logger.trace('Formatting value: ' + _control.value + ' -> ' + value, _control);
                _control.value = value;
            }
        }

        const validation = new window.mcb.forms.validation.ValidationResult(true);
        if (_thisField.validation.required === true) {
            validation.aggregate(window.mcb.forms.validation.validateRequired(_thisField.alias, value));
        }

        if (validation.isValid()) {
            if (_thisField.validation.regex !== null) {
                validation.aggregate(window.mcb.forms.validation.validateByRegEx(_thisField.alias, value, _thisField.validation.regex, _thisField.validation.regexError));
            }

            if (_thisField.validation.isNumeric === true) {
                validation.aggregate(window.mcb.forms.validation.validateNumbersOnly(_thisField.alias, value, _thisField.validation.min));
            }

            if (_thisField.validation.minLength !== null) {
                validation.aggregate(window.mcb.forms.validation.validateMinLength(_thisField.alias, value, _thisField.validation.minLength));
            }

            if (_thisField.validation.maxLength !== null) {
                validation.aggregate(window.mcb.forms.validation.validateMaxLength(_thisField.alias, value, _thisField.validation.maxLength));
            }

            if (_thisField.validation.regex !== null) {
                validation.aggregate(window.mcb.forms.validation.validateByRegEx(_thisField.alias, value, _thisField.validation.regex, _thisField.validation.regexError));
            }

            if (_thisField.validation.modulus !== null) {
                validation.aggregate(window.mcb.forms.validation.validateModulus(_thisField.alias, value, _thisField.validation.modulus.modulus, _thisField.validation.modulus.weights, _thisField.validation.modulus.error));
            }

            if (_thisField.validation.isEmail) {
                validation.aggregate(window.mcb.forms.validation.validateEmail(_thisField.alias, value, _thisField.validation.regexError));
            }
        }

        validation.render(_thisField.formId, _validatedControlWrapper, _validationCanvas);
        if (validation.isValid()) {
            if (allowValueFormatting && value !== "") {
                if (_thisField.settings.data.type === 'postal') {
                    _control.value = value.toUpperCase();
                }
                else if (_thisField.settings.data.type === 'orgno') {
                    _control.value = value.substring(0, 3) + ' ' + value.substring(3, 6) + ' ' + value.substring(6, 10);
                }
                else if (_thisField.settings.data.type === 'cpr') {
                    _control.value = value.replace('-', '');
                }
                else if (valueAsNumber !== null) {
                    _control.value = "" + valueAsNumber;
                    return valueAsNumber;
                }
                else if (_thisField.validation.prepend !== null && value.length < _thisField.validation.prependLength) {
                    _control.value = value.padStart(_thisField.validation.prependLength, _thisField.validation.prepend);
                }
            }

            return _control.value;
        }

        return null;
    };

    const setValue = function (value) {
        _logger.trace('setValue called: ' + _control.value + ' -> ' + value, _control);
        _control.value = value;
        return true;
    }

    return _ = {
        render: render,
        getValue: getValue,
        setValue: setValue
    };
};
